import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IChat } from '@interfaces/index';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss'
})
export class SidenavComponent {

  @Input() chats: IChat[] = [];
  @Output() onNewChat: EventEmitter<void> = new EventEmitter();

  chat: IChat | null = null;
  today: IChat[] = [];
  last7Days: IChat[] = [];
  sidebarVisible: boolean = false;

  ngOnChanges() {
    this.filterChats()
  }
  
  filterChats() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const sevenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 7));
    
    this.today = this.chats.filter(chat => this.isToday(chat.created_at));
    this.last7Days = this.chats.filter(chat => this.isWithinLast7Days(chat.created_at) && !this.isToday(chat.created_at));
  }

  isToday(dateInput: string | Date): boolean {
    const date = new Date(dateInput);
    const today = new Date();
    return date.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0);
  }
  
  isWithinLast7Days(dateInput: string | Date): boolean {
    const date = new Date(dateInput);
    const today = new Date();
    const sevenDaysAgo = new Date(today).setDate(today.getDate() - 7);
    return date > new Date(sevenDaysAgo) && date < today;
  }

  startNewChat() {
    this.onNewChat.emit();
  }

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
    const sidnavContainer = document.querySelector('.sidnav-container');
    if (sidnavContainer) {
      sidnavContainer.classList.toggle('active', this.sidebarVisible);
    }
  }
 
}

